// components/widgets/Module5/NarrativeSequence.jsx
import React from "react";
import AutoTimelineSequence from "../../../MilestoneSequence/AutoTimelineSequence.jsx";
import StakeholderCardWithData from "../../Stakeholders/stakeholderValuesAndInterests/StakeholderCardWithData.jsx";
import MeetingPersonalityCard from "../../Module4/MeetingPersonalityCard.jsx";
import CurrentStateProfileCard from "../../Identity/CurrentYou/CompletionPages/CurrentStateProfileCard.jsx";
import UnmetNeedsCard from "../../UnmetNeeds/UnmetNeedsCard.jsx";
import StakeholderListCard from "../../Stakeholders/StakeholderListCard.jsx";
import NarrativeCompletionCard from "./NarrativeCompletionCard";

export default function NarrativeSequence({ userId, selectedCard, onNextStep }) {
  const steps = [
    {
      position: "center",
      circles: { left: "", center: "", right: "Future Identity" },
      component: CurrentStateProfileCard,
      props: {
        mode: "api",
        userId,
      },
      duration: 5000,
    },
    {
      position: "left",
      circles: { left: "", center: "Value Mapping", right: "Value & Pitch" },
      component: UnmetNeedsCard,
      props: {
        mode: "api",
        userId,
      },
      duration: 5000,
    },
    {
      position: "center",
      circles: {
        left: "1st Meeting with Career Coach",
        center: "",
        right: "Visibility Mapping",
      },
      component: StakeholderListCard,
      props: {
        mode: "api",
        userId,
      },
      duration: 5000,
    },
    {
      position: "center",
      circles: {
        left: "Visibility Mapping",
        center: "",
        right: "What’s in it for me?",
      },
      component: StakeholderCardWithData,
      props: {
        mode: "api",
        userId,
      },
      duration: 5000,
    },
    {
      position: "center",
      circles: {
        left: "What’s in it for me?",
        center: "",
        right: "2nd Meeting...",
      },
      component: MeetingPersonalityCard,
      props: {
        mode: "api",
        userId,
      },
      duration: 5000,
    },
    // final slide – your narrative card
    {
      position: "center",
      circles: {
        left: "2nd Meeting with Career Coach",
        center: "",
        right: "3rd Meeting with Career Coach",
      },
      component: NarrativeCompletionCard,
        props: {
            heroTitle: selectedCard?.name || "My Narrative",
            heroSubtitle: selectedCard?.tagline || "",
            bullets: Array.isArray(selectedCard?.bullets) ? selectedCard.bullets : [],
        },
        final: true,
    },
  ];

  return <AutoTimelineSequence steps={steps} onComplete={onNextStep} />;
}

